export default "__VITE_ASSET__BjpLaY91__"